import React from "react";
import Rotas from "./Services/Rotas.jsx";

function App() {
  return <Rotas />;
}

export default App;
